import { cloneElement, type JSX } from "react";
import { twMerge } from "tailwind-merge";

export function updateClassName(element: JSX.Element, className: string): JSX.Element {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-argument,@typescript-eslint/no-unsafe-member-access
  return cloneElement(element, { className: twMerge(element.props.className, className) });
}
